/**
 * The module a record belongs to, as the API writes it: the code string.
 */
import { z } from 'zod';
import { MODULE_CODES } from '../features/modules/modules';

export const moduleSchema = z.enum(MODULE_CODES);

/** For records an older response may not carry a module on: O2C, as before. */
export const moduleOrDefaultSchema = moduleSchema.default('O2C');

/** `GET /reference/modules`. */
export const moduleInfoSchema = z.object({
	code: moduleSchema,
	name: z.string(),
	description: z.string().nullable().optional(),
});

export type ModuleInfo = z.infer<typeof moduleInfoSchema>;
